import React from 'react';

import ArchiveRecordLabel from 'archive/components/ArchiveRecordLabel';
import {ProjectSummary, Source} from 'constants/SourceConstants';
import {ButtonStyle} from 'ui-library/buttons/Button';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';
import Modal from 'ui-library/modals/Modal';
import SortableTable from 'ui-library/SortableTable';

import * as TeamDAO from './TeamDAO';

interface DeleteTeamModalProps {
  team: {id: string; name: string};
  onRequestSubmit: (success: boolean) => void;
  onRequestClose: () => void;
}

interface State {
  projects: Array<ProjectSummary> | null;
}
class DeleteTeamModal extends React.Component<DeleteTeamModalProps, State> {
  constructor(props: DeleteTeamModalProps) {
    super(props);
    this.state = {
      projects: null,
    };
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidMount = async () => {
    const {projects: allVisibleProjects} = await TeamDAO.fetchProjects(this.props.team.id);
    const projects = allVisibleProjects;
    this.setState({projects});
  };

  _hasLoaded(): boolean {
    return Boolean(this.state.projects);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleDelete = () => {
    this.props.onRequestSubmit(true);
    this.props.onRequestClose();
  };

  render(): JSX.Element {
    return (
      <Modal
        enableRedesign={true}
        title="Confirm Delete Team"
        onRequestClose={this.props.onRequestClose}
        buttons={[
          {
            text: 'Permanently Delete',
            onClick: this._handleDelete,
            disabled: !this._hasLoaded(),
            style: ButtonStyle.NEGATIVE,
          },
        ]}
      >
        {this._hasLoaded() ? (
          <div>
            <p>
              <strong> Are you sure you want to delete {this.props.team.name}?</strong>
            </p>
            <p>
              This action is not reversible. The team will be permanently deleted, and all members will be
              removed.{' '}
              <strong>Users in this team may lose access to projects that were shared with this team</strong>,
              if the project is not otherwise shared with those users, or shared with a different team or
              organization that those users are members of.{' '}
            </p>{' '}
            <p>The following projects have the team as a collaborator. </p>
            <SortableTable
              columns={[
                SortableTable.defaultColumn('Name', 'name', {
                  render: (column, project: Source) => (
                    <span>
                      {project.name}
                      <ArchiveRecordLabel item={project} />
                    </span>
                  ),
                }),
              ]}
              rows={this.state.projects!}
            />
          </div>
        ) : (
          <CenteredHorizontalThrobber />
        )}
      </Modal>
    );
  }
}

export default DeleteTeamModal;
